import { useFormikContext } from "formik";
import { FC, ReactElement } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";

interface SummaryStepProps {
    originalSelectedRows: any[];
    onBack: (e: any) => void;
    idPath: string;
}

const SummaryStep: FC<SummaryStepProps> = ({  originalSelectedRows, onBack, idPath}) => {
    const { values, submitForm } = useFormikContext<any>();
    const { translate } = useLocale();
    const selectedRows = values.selectedRows || [];
    const toBeUnassignedRows = originalSelectedRows.filter((row: any) => !selectedRows.some((current: any) => current.id.toString() === row[idPath]));
    const toBeAssignedRows = selectedRows.filter((row: any) =>!originalSelectedRows.some((original: any) => original[idPath] === row.id.toString()));

    const getItemsList = (items: any[], title: string): ReactElement => {
        if(items.length === 0) {
            return <div className="flex flex-row flex-1">
                <h4 className="p-1 text-xs text-gray-600 w-1/3">{title}</h4>
                <ul className="flex flex-col w-1/3">
                    <li className="p-1 text-sm">{translate.byKey(TranslationKeys.none)}</li>
                </ul>
            </div>
        }

        return <div className="flex flex-row flex-1">
            <h4 className="p-1 text-xs text-gray-600 w-1/3">{title}</h4>
            <ul className="flex flex-col w-1/3">
                {items.map((row: any) => (
                    <li key={row.id} className="p-1 text-sm"> {row.name} </li>
                ))}
            </ul>
        </div>
    } 

    return <div className="pt-3 pr-3 flex flex-col h-full relative">
        <div className={`text-portal-blue-primary-shade2 text-xl font-semibold`} >
            {translate.byKey(TranslationKeys.summary)}
        </div>
        <div className="flex-1 overflow-y-auto pr-1 mb-16">
            {/* To Be Added */}
            {getItemsList(toBeAssignedRows, translate.byKey(TranslationKeys.toBeAssigned))}
            <hr />
            {/* To Be Removed */}
            {getItemsList(toBeUnassignedRows, translate.byKey(TranslationKeys.toBeUnassigned))}
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={onBack}>
                    {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    data-cy="submitButton"
                    onClick={submitForm}>
                    {translate.byKey(TranslationKeys.submit)}
                </button>
            </div>
        </div>
    </div>
}

export default SummaryStep;